import React from 'react';

/**
 * SectionCard - Consistent titled container for charts, tables, and breakdowns.
 */
const SectionCard = ({ title, icon: Icon, children, loading = false, className = '' }) => {
    return (
        <div className={`sd-card sd-card--section ${className}`}>
            {title && (
                <div className="sd-card__header">
                    {Icon && <Icon size={18} className="sd-card__icon" />}
                    <h3 className="sd-card__title">{title}</h3>
                </div>
            )}
            {loading ? (
                <div className="sd-card__body" style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    <div className="loading-skeleton" style={{ width: '33%', height: '0.75rem', borderRadius: 'var(--radius-sm)' }} />
                    <div className="loading-skeleton" style={{ width: '100%', height: '7rem', borderRadius: 'var(--radius-lg)' }} />
                </div>
            ) : (
                children
            )}
        </div>
    );
};

export default SectionCard;
